import React from 'react';

export const PreferencesBlankIllustration = (props: React.ComponentPropsWithoutRef<'svg'>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="187" height="122" fill="none" viewBox="0 0 187 122" {...props}>
    <path stroke="#BCC3CE" strokeDasharray="4 4" strokeLinejoin="round" strokeWidth="0.5" d="M94.974 80V48"></path>
    <path
      stroke="url(#paint0_linear_13714_411615)"
      strokeDasharray="4 4"
      strokeLinejoin="round"
      strokeWidth="0.5"
      d="M154.979 80V68.794c0-.53-.352-1.04-.978-1.414-.625-.375-1.474-.586-2.358-.586H98.27c-.884 0-1.733-.21-2.358-.586-.626-.375-.977-.884-.977-1.414V48"
    ></path>
    <path
      stroke="#BCC3CE"
      strokeDasharray="4 4"
      strokeLinejoin="round"
      strokeWidth="0.5"
      d="M22.755 80V68.794c0-.53.423-1.04 1.175-1.414.753-.375 1.773-.586 2.837-.586h64.195c1.064 0 2.085-.21 2.837-.586.752-.375 1.175-.884 1.175-1.414V48"
    ></path>
    <path
      stroke="#DD2450"
      strokeDasharray="4 4"
      strokeLinejoin="round"
      strokeOpacity="0.75"
      strokeWidth="0.5"
      d="M22.755 80V68.794c0-.53.423-1.04 1.175-1.414.753-.375 1.773-.586 2.837-.586h64.195c1.064 0 2.085-.21 2.837-.586.752-.375 1.175-.884 1.175-1.414V48"
    ></path>
    <path
      stroke="#DD2450"
      strokeOpacity="0.75"
      strokeWidth="0.75"
      d="M117.5.375h-48A7.625 7.625 0 0 0 61.875 8v30a7.625 7.625 0 0 0 7.625 7.625h48A7.625 7.625 0 0 0 125.125 38V8A7.625 7.625 0 0 0 117.5.375Z"
    ></path>
    <path fill="#fff" d="M115.5 4h-44a6 6 0 0 0-6 6v26a6 6 0 0 0 6 6h44a6 6 0 0 0 6-6V10a6 6 0 0 0-6-6"></path>
    <path
      stroke="#FB3748"
      strokeOpacity="0.24"
      strokeWidth="0.75"
      d="M115.5 4.375h-44A5.625 5.625 0 0 0 65.875 10v26a5.625 5.625 0 0 0 5.625 5.625h44A5.625 5.625 0 0 0 121.125 36V10a5.625 5.625 0 0 0-5.625-5.625Z"
    ></path>
    <path
      fill="#D82651"
      fillOpacity="0.75"
      d="M92.03 22.7a1.35 1.35 0 1 1 0-2.7 1.35 1.35 0 0 1 0 2.7m.27 4.949V25.64c0-.293.086-.562.242-.803a3.88 3.88 0 0 0-3.02.85A4.8 4.8 0 0 0 92.3 27.65m-3.328-3.053A5.08 5.08 0 0 1 92 23.6c.626 0 1.226.113 1.78.32a5 5 0 0 1 1.82-.32c.996 0 1.911.254 2.524.694a4.8 4.8 0 1 0-9.152.302m8.655.856c-.235-.32-1.024-.652-2.027-.652-1.204 0-2.1.478-2.1.84v2.16a4.8 4.8 0 0 0 4.127-2.348M93.5 29a6 6 0 1 1 0-12 6 6 0 0 1 0 12m2.1-5.7a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4"
    ></path>
    <path
      stroke="#DD2450"
      strokeOpacity="0.75"
      strokeWidth="0.75"
      d="M44.625 114V88A7.625 7.625 0 0 0 37 80.375H11A7.625 7.625 0 0 0 3.375 88v26A7.625 7.625 0 0 0 11 121.625h26A7.625 7.625 0 0 0 44.625 114Z"
    ></path>
    <path fill="#fff" d="M41 112V90a6 6 0 0 0-6-6H13a6 6 0 0 0-6 6v22a6 6 0 0 0 6 6h22a6 6 0 0 0 6-6"></path>
    <path
      stroke="#FB3748"
      strokeOpacity="0.24"
      strokeWidth="0.75"
      d="M40.625 112V90A5.625 5.625 0 0 0 35 84.375H13A5.625 5.625 0 0 0 7.375 90v22A5.625 5.625 0 0 0 13 117.625h22A5.625 5.625 0 0 0 40.625 112Z"
    ></path>
    <path
      fill="#DD2450"
      fillOpacity="0.75"
      d="M23.048 97.25H20.25v4.158l-2.245-1.662a1.5 1.5 0 0 1 .602-1.073l.518-.385V97.25c0-.621.504-1.125 1.125-1.125h1.795l1.17-.865a1.315 1.315 0 0 1 1.57-.002l1.17.867h1.795c.621 0 1.125.504 1.125 1.125v1.038l.518.385a1.5 1.5 0 0 1 .602 1.073l-2.245 1.662V97.25h-4.704zM18 105.5v-4.826l5.1 3.778a1.51 1.51 0 0 0 1.8 0l5.1-3.778v4.826c0 .827-.673 1.5-1.5 1.5h-9c-.827 0-1.5-.673-1.5-1.5m4.125-6.75h3.75c.206 0 .375.169.375.375a.376.376 0 0 1-.375.375h-3.75a.376.376 0 0 1-.375-.375c0-.206.169-.375.375-.375m0 1.5h3.75c.206 0 .375.169.375.375a.376.376 0 0 1-.375.375h-3.75a.376.376 0 0 1-.375-.375c0-.206.169-.375.375-.375"
    ></path>
    <path
      stroke="#DD2450"
      strokeOpacity="0.75"
      strokeWidth="0.027"
      d="M20.25 97.236h-.014v4.145L18.02 99.74c.04-.418.255-.805.596-1.056l.518-.385.006.008V97.25c0-.614.498-1.111 1.111-1.111h1.795v.003l.008-.006 1.17-.865a1.3 1.3 0 0 1 1.554-.002l1.17.867-.002.003h1.805c.613 0 1.111.498 1.111 1.111v1.038h-.009l.015.011.518.385c.341.251.557.638.596 1.056l-2.217 1.641v-4.145H20.25Zm4.658 7.227 5.078-3.762v4.799c0 .82-.666 1.486-1.486 1.486h-9c-.82 0-1.486-.666-1.486-1.486v-4.799l5.078 3.762c.262.194.582.301.908.301s.646-.104.908-.301Zm.967-5.7a.362.362 0 0 1 0 .723h-3.75a.36.36 0 0 1-.361-.361c0-.199.162-.361.361-.361zm0 1.501c.199 0 .361.162.361.361a.36.36 0 0 1-.361.361h-3.75a.36.36 0 0 1-.361-.361c0-.199.162-.361.361-.361z"
    ></path>
    <path
      stroke="#E1E4EA"
      strokeWidth="0.75"
      d="M116.625 114V88A7.625 7.625 0 0 0 109 80.375H83A7.625 7.625 0 0 0 75.375 88v26A7.625 7.625 0 0 0 83 121.625h26a7.625 7.625 0 0 0 7.625-7.625Z"
    ></path>
    <path
      fill="#fff"
      d="M112.625 112V90A5.625 5.625 0 0 0 107 84.375H85A5.625 5.625 0 0 0 79.375 90v22A5.625 5.625 0 0 0 85 117.625h22a5.624 5.624 0 0 0 5.625-5.625"
    ></path>
    <path
      stroke="#F2F5F8"
      strokeWidth="0.75"
      d="M112.625 112V90A5.625 5.625 0 0 0 107 84.375H85A5.625 5.625 0 0 0 79.375 90v22A5.625 5.625 0 0 0 85 117.625h22a5.624 5.624 0 0 0 5.625-5.625Z"
    ></path>
    <path
      fill="#E1E4EA"
      d="M96 107c.688 0 1.25-.554 1.25-1.231h-2.5c0 .677.563 1.231 1.25 1.231m3.75-3.692v-3.077c0-1.89-1.019-3.471-2.812-3.89v-.418A.93.93 0 0 0 96 95a.93.93 0 0 0-.937.923v.418c-1.788.419-2.813 1.994-2.813 3.89v3.077l-1.25 1.23v.616h10v-.616zm-1.25.615h-5v-3.692c0-1.526.944-2.77 2.5-2.77s2.5 1.244 2.5 2.77z"
    ></path>
    <path
      stroke="#E1E4EA"
      strokeWidth="0.75"
      d="M181.625 114V88A7.625 7.625 0 0 0 174 80.375h-26A7.625 7.625 0 0 0 140.375 88v26a7.625 7.625 0 0 0 7.625 7.625h26a7.625 7.625 0 0 0 7.625-7.625Z"
    ></path>
    <path
      fill="#fff"
      d="M177.625 112V90A5.625 5.625 0 0 0 172 84.375h-22A5.625 5.625 0 0 0 144.375 90v22a5.624 5.624 0 0 0 5.625 5.625h22a5.624 5.624 0 0 0 5.625-5.625"
    ></path>
    <path
      stroke="#F2F5F8"
      strokeWidth="0.75"
      d="M177.625 112V90A5.625 5.625 0 0 0 172 84.375h-22A5.625 5.625 0 0 0 144.375 90v22a5.624 5.624 0 0 0 5.625 5.625h22a5.624 5.624 0 0 0 5.625-5.625Z"
    ></path>
    <path
      fill="#E1E4EA"
      d="m157.077 99.762-.244 1.166-.333 1.572.851.009.645-2.134-.46-.306zm0 0a.136.136 0 0 1 .074-.25h.6a.515.515 0 0 0 .514-.513.515.515 0 0 0-.514-.514h-.6c-.642 0-1.163.522-1.163 1.164 0 .392.196.755.518.973l.23.153.229.153.23.154.23.153a.136.136 0 0 1-.074.25h-.85a.515.515 0 0 0 0 1.027m.576-2.75-.576 2.75zm7.56-1.277h.613c.283 0 .514.231.514.514a.515.515 0 0 1-.514.513h-.6a.137.137 0 0 0-.136.137c0 .045.023.088.063.113l.918.613a1.164 1.164 0 0 1-.645 2.134zm0 0v.004a1.164 1.164 0 0 0-.632 2.133l.919.613c.04.025.063.068.063.113 0 .074-.06.137-.137.137h-.849a.515.515 0 0 0-.514.513c0 .283.231.514.514.514l.849-.003zm-3.636 8.498h-.014v.004a9.6 9.6 0 0 1-3.234-.559l.003-.01-.016.012c-.371.271-.98.642-1.694.954-.749.325-1.65.602-2.544.602a.485.485 0 0 1-.45-.301.48.48 0 0 1 .103-.528l.009-.01.014-.015.004-.004.023-.024q.056-.062.154-.179c.128-.157.304-.389.476-.677.313-.52.611-1.203.671-1.971h.006l-.01-.01c-.935-1.063-1.487-2.363-1.487-3.768 0-3.58 3.572-6.485 7.986-6.485s7.985 2.905 7.985 6.485c0 3.579-3.572 6.484-7.985 6.484m-1.089-8.292a.52.52 0 0 0-.575-.18.52.52 0 0 0-.35.488v2.999a.515.515 0 0 0 1.028 0v-1.458l.575.767a.517.517 0 0 0 .822 0l.575-.767v1.458c0 .283.231.514.514.514a.515.515 0 0 0 .513-.514v-3a.513.513 0 0 0-.924-.308l-1.089 1.451zm-1.397 2.654c0-.392-.193-.755-.519-.97l-.645 2.134c.642 0 1.164-.522 1.164-1.164"
    ></path>
    <path
      stroke="#E1E4EA"
      strokeWidth="0.027"
      d="m157.077 99.762-.244 1.166-.333 1.572.851.009m-.274-2.747a.136.136 0 0 1 .074-.25h.6a.515.515 0 0 0 .514-.513.515.515 0 0 0-.514-.514h-.6c-.642 0-1.163.522-1.163 1.164 0 .392.196.755.518.973l.23.153.229.153.23.154.23.153a.136.136 0 0 1-.074.25h-.85a.515.515 0 0 0 0 1.027m.576-2.75-.576 2.75m.576-2.75.459.307.46.306m0 0a1.165 1.165 0 0 1-.645 2.134m.645-2.134-.645 2.134m-.85.003.85-.003m7.286-4.024h.613c.283 0 .514.231.514.514a.515.515 0 0 1-.514.513h-.6a.137.137 0 0 0-.136.137c0 .045.023.088.063.113l.918.613a1.164 1.164 0 0 1-.645 2.134m-.213-4.024.213 4.024m-.213-4.024v.004a1.164 1.164 0 0 0-.632 2.133l.919.613c.04.025.063.068.063.113 0 .074-.06.137-.137.137h-.849a.515.515 0 0 0-.514.513c0 .283.231.514.514.514l.849-.003m-3.849 4.474h-.014v.004a9.6 9.6 0 0 1-3.234-.559l.003-.01-.016.012c-.371.271-.98.642-1.694.954-.749.325-1.65.602-2.544.602a.485.485 0 0 1-.45-.301.48.48 0 0 1 .103-.528l.009-.01.014-.015.004-.004.023-.024q.056-.062.154-.179c.128-.157.304-.389.476-.677.313-.52.611-1.203.671-1.971h.006l-.01-.01c-.935-1.063-1.487-2.363-1.487-3.768 0-3.58 3.572-6.485 7.986-6.485s7.985 2.905 7.985 6.485c0 3.579-3.572 6.484-7.985 6.484Zm-1.089-8.292a.52.52 0 0 0-.575-.18.52.52 0 0 0-.35.488v2.999a.515.515 0 0 0 1.028 0v-1.458l.575.767a.517.517 0 0 0 .822 0l.575-.767v1.458c0 .283.231.514.514.514a.515.515 0 0 0 .513-.514v-3a.513.513 0 0 0-.924-.308l-1.089 1.451z"
    ></path>
    <defs>
      <linearGradient
        id="paint0_linear_13714_411615"
        x1="68.97"
        x2="105.015"
        y1="58"
        y2="107.916"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BCC3CE"></stop>
        <stop offset="1" stopColor="#fff"></stop>
      </linearGradient>
    </defs>
  </svg>
);
